import React, {useEffect, useState} from 'react'
import AddIcon from '@material-ui/icons/Add';
import { Modal, ModalHeader, ModalBody, ModalFooter, Card, CardBody } from 'reactstrap';
import TimeModalForm from '../modals/time-modal/time-modal';
import CancelIcon from '@material-ui/icons/Cancel';
import ChipsButton from '../chips-button/chips-button';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import _ from 'lodash';

interface DayRangeProps {
    from: string;
    to: string;
}

interface CustomTimeCardProps {
    title: string;
    description: string;
    dayRanges: DayRangeProps[];
    dayNumber: number;
    onChange: (dayRanges: DayRangeProps[]) => void;
    tmpTime: object;
}

const CustomTimeCard: React.FC<CustomTimeCardProps> = (props) => {

    const [modal, setModal] = useState(false);
    const [chipsButtons, setChipsButtons] = useState<DayRangeProps[]>(props.dayRanges);
    const { t } = useTranslation();
    const toggle = () => setModal(!modal);
    useEffect(() => {
        setChipsButtons(props.dayRanges);
    }, [props.dayRanges]);
    const handleSubmit = () => {
        const from = _.get(props.tmpTime, 'from', '');
        const to = _.get(props.tmpTime, 'to', '');
        if (from && to) {
            const chips = _.cloneDeep(chipsButtons);
            chips.push({
                from: from + ':00',
                to: to + ':00'
            })
            setChipsButtons(chips);
            props.onChange(chips);
            toggle();
        }
    }

    const removeChipsButtons = (index: number) => {
        const chips = chipsButtons.length === 1 ? [] : _.cloneDeep(chipsButtons).splice(index, 1);
        setChipsButtons(chips);
        props.onChange(chips);
    }
    return (
        <Card className='default-card'>
            <CardBody className='custom-time-card'>
                <div className='title'>
                    <span>{props.title}</span>
                </div>
                <div>
                    <span>{props.description}</span>
                </div>
                <div className='d-flex flex-row flex-wrap chips-buttons-container'>
                    {
                        chipsButtons.map((chipsButton, index) => <ChipsButton label={chipsButton.from + ' - ' + chipsButton.to} icon={<CancelIcon />} onIconClick={() => removeChipsButtons(index)} />)
                    }
                    <ChipsButton label={t('add')} icon={<AddIcon />} onClick={toggle} />
                </div>
                <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle}>{t('customTimeCard.modal.title')}</ModalHeader>
                    <ModalBody className='d-flex justify-content-around'>
                        <TimeModalForm dayNumber={props.dayNumber}/>
                    </ModalBody>
                    <ModalFooter>
                <Button variant="outlined" color="primary" onClick={handleSubmit}>{t('apply')}</Button>
                    </ModalFooter>
                </Modal>
            </CardBody>
        </Card>
    )
}


export default connect(null)(CustomTimeCard);